import { CustomerProfilePageProps } from './customer-profile-page.types'
import styles from './customer-profile-page.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import {
  EntityInfoNameLine,
  LabeledLine,
  PageContainer,
  PageHeader,
  SectionContainer,
  Text1,
  HorizontalLine,
  ImagePortrait,
} from '@touche-lts/panel-ui/dist'
import {
  IconCalendar,
  IconEmail,
  IconUserManagement
} from 'assets/icons'
import { CustomerHistoryTable } from '../customers-store-history-table'
import { OrdersTable } from '../../orders/orders-table/orders-table'
import { useGetIsResponsiveScreen } from 'hooks/custom-hooks'

const CustomerProfilePageComponent = (props: CustomerProfilePageProps) => {
  const {
    className,
    style,
    match: {
      params: { }
    },
    history: { push }
  } = props

  const {
    customerProfilePageStore: {
      loadCustomer,
      customerFullName,
      userImageUrl,
      customer,
      customerAddedOn,
      clearStore
    }
  } = useRootStore()

  useEffect(() => {
    loadCustomer()
    return clearStore
  }, [loadCustomer, clearStore])

  const {isResponsive:isLargeMobile} = useGetIsResponsiveScreen('(max-width:920px)')

  if (!customer) return null


  return (
    <PageContainer className={cl(styles.scrollable, className)} style={ {...style,  overflowX : "hidden" }}>
      <PageHeader
        navSegments={[
          {
            icon: IconUserManagement,
            label: 'Customer',
            iconProps: { viewBox: '0 0 22 22' },
            onClick: () => push(`/customers`)
          },
          {
            label: customerFullName
          }
        ]}
      />
      <SectionContainer extraPaddingBottom>
        <EntityInfoNameLine
          imageProps={{ src: userImageUrl }}
          entityName={customerFullName}
        />
        <LabeledLine
          labelIcon={IconEmail}
          label='Email'
          className={styles.labeledLine}
        >
          {
            !isLargeMobile && <Text1>{customer?.user.emailAddress}</Text1>
          }
        </LabeledLine>
        {
          isLargeMobile && <Text1>{customer?.user.emailAddress}</Text1> 
        }
        <LabeledLine
          labelIcon={IconCalendar}
          label="Registered on"
          className={styles.labeledLine}
        >
          {
            !isLargeMobile && <Text1>{customerAddedOn}</Text1>
          }
        </LabeledLine>
        {
          isLargeMobile && <Text1>{customerAddedOn}</Text1> 
        }
        <Text1 style={{ marginTop: 15 }}>Reset password</Text1>
        <HorizontalLine />
        <Text1 bold className={styles.labeledLine}>
          Customer image
        </Text1>
        <div className={styles.blockContainer}>
          <ImagePortrait width={94} src={userImageUrl} />
        </div>

      </SectionContainer>
      <OrdersTable />
      <CustomerHistoryTable />
    </PageContainer>
  )
}

const CustomerProfilePage = observer(CustomerProfilePageComponent)
export { CustomerProfilePage }
